document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.querySelector('cart-drawer');
    const sidebar = document.querySelector('.cart-drawer-sidebar');

    if (!cartDrawer || !sidebar) return;

    // Drawer üzerindeki değişiklikleri (open attribute) izle
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (cartDrawer.hasAttribute('open')) {
                    sidebar.classList.add('is-visible');
                } else {
                    sidebar.classList.remove('is-visible');
                }
            }
        });
    });

    observer.observe(cartDrawer, { attributes: true });
});